export var WidgetEvent;
(function (WidgetEvent) {
    WidgetEvent["AvailableRoutes"] = "availableRoutes";
    WidgetEvent["ChainPinned"] = "chainPinned";
    WidgetEvent["ContactSupport"] = "contactSupport";
    WidgetEvent["DestinationChainTokenSelected"] = "destinationChainTokenSelected";
    WidgetEvent["FormFieldChanged"] = "formFieldChanged";
    WidgetEvent["LowAddressActivityConfirmed"] = "lowAddressActivityConfirmed";
    WidgetEvent["PageEntered"] = "pageEntered";
    /**
     * @deprecated Use `PageEntered` event instead.
     */
    WidgetEvent["ReviewTransactionPageEntered"] = "reviewTransactionPageEntered";
    WidgetEvent["RouteExecutionCompleted"] = "routeExecutionCompleted";
    WidgetEvent["RouteExecutionFailed"] = "routeExecutionFailed";
    WidgetEvent["RouteExecutionStarted"] = "routeExecutionStarted";
    WidgetEvent["RouteExecutionUpdated"] = "routeExecutionUpdated";
    WidgetEvent["RouteHighValueLoss"] = "routeHighValueLoss";
    WidgetEvent["RouteSelected"] = "routeSelected";
    WidgetEvent["SendToWalletToggled"] = "sendToWalletToggled";
    WidgetEvent["SettingUpdated"] = "settingUpdated";
    WidgetEvent["SourceChainTokenSelected"] = "sourceChainTokenSelected";
    WidgetEvent["TokenSearch"] = "tokenSearch";
    WidgetEvent["WidgetExpanded"] = "widgetExpanded";
})(WidgetEvent || (WidgetEvent = {}));
//# sourceMappingURL=events.js.map